<template>
<v-dialog v-model="dialog" scrollable max-width="1024px" transition="dialog-transition" :fullscreen="$vuetify.breakpoint.smAndDown" persistent @keydown.esc="emitExit()">
    <v-card flat class="hotel-modal" id="hotel-description">
        <v-card-title>
            <div class="pl-2 hotel-modal-header">
                {{ $t('hotel.modal.detail.title') }}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text class="scroll-card">
            <v-form v-model="valid" ref="hotel_details">
                <div class="py-3">
                    <v-row>
                        <v-col md="8" cols="12" class="py-0">
                            <v-text-field class="pa-0 my-1" :label="$t('hotel.detail.name')" v-model="item.name" :rules="rules.name" required @input="is_dirty=true" />
                        </v-col>
                        <v-col md="4" cols="12" class="py-0">
                            <v-select class="pa-0 my-1" :label="$t('hotel.detail.unit_type')" v-model="item.unit_type" :items="config.unit_type_slug" required :rules="rules.type" :hint="$t('hotel.modal.detail.info_text.unit_type')" persistent-hint
                                :menu-props="{transition:'scale-transition', 'offset-y': ''}">
                                <template v-slot:selection="data">
                                    <span class="text-capitalize">
                                        {{$t('hotel.detail.unit_types.' + data.item)}}
                                    </span>
                                </template>
                                <template v-slot:item="data">
                                    <span class="text-capitalize">
                                        {{$t('hotel.detail.unit_types.' + data.item)}}
                                    </span>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="4" cols="12" class="py-0">
                            <v-checkbox class="pa-0 my-1" v-model="chain" :label="$t('hotel.detail.chain')" color="primary"></v-checkbox>
                        </v-col>
                        <v-col md="8" cols="12" class="py-0">
                            <v-text-field v-if="chain" class="pa-0 my-1" :label="$t('hotel.detail.chain_name')" v-model="item.static.defaults.chain" :required="chain" :rules="rule_chain" />
                        </v-col>
                    </v-row>
                    <v-checkbox class="ma-0 pa-0 mb-0-v-input__slot" v-model="clasification" :label="$t('hotel.detail.classification')" color="primary" :hint="$t('hotel.modal.detail.info_text.clasification')" persistent-hint></v-checkbox>
                    <v-row v-if="clasification">
                        <v-col cols="12" md="4" class="py-0">
                            <v-rating v-model="item.static.defaults.stars" color="yellow" background-color="yellow"></v-rating>
                        </v-col>
                        <v-col cols="12" md="8" class="py-0">
                            <v-text-field class="pa-0 my-1" :label="$t('hotel.detail.nr_classification')" v-model="item.static.defaults.certificate" :required="clasification" :rules="rule_clasification" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="2" class="py-0">
                            <v-text-field :label="$t('hotel.detail.capacity')" v-model="item.static.defaults.capacity" required :hint="$t('hotel.modal.detail.info_text.capacity')" persistent-hint />
                        </v-col>
                        <v-col cols="12" md="5" class="py-0" v-if="admin">
                            <v-select :items="context" v-model="item.context" item-text="text" item-value="value" :label="$t('hotel.detail.context')" :hint="$t('hotel.modal.detail.info_text.context')" persistent-hint required :rules="rules.context" />
                        </v-col>
                        <v-col cols="12" md="5" class="py-0" v-if="admin">
                            <v-select :items="status_hotel" v-model="item.status" item-text="text" item-value="value" :label="$t('hotel.detail.status.label')" />
                        </v-col>
                    </v-row>
                </div>

                <v-row :class="{'d-none':!admin}">
                    <v-col cols="12" sm="3" class="py-0">
                        <suglify :slugify="item.slug" :slug.sync="item.slug" :extras="{'*' : ''}">
                            <v-text-field v-model="item.slug" :label="$t('hotel.detail.slug')" :rules="rules.slug" :hint="$t('hotel.modal.detail.info_text.slug')" persistent-hint />
                        </suglify>
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0" v-if="admin">
                        <v-text-field v-model="item.net_commission" :label="$t('hotel.detail.net_commission')" :hint="$t('hotel.modal.detail.info_text.net_commission')" persistent-hint />
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0" v-if="admin">
                        <v-text-field v-model="item.gross_commission" :label="$t('hotel.detail.gross_commission')" :hint="$t('hotel.modal.detail.info_text.gross_commission')" persistent-hint />
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0" v-if="admin">
                        <v-select :items="boolean_values" v-model="item.static.for_testing" item-text="text" item-value="value" :label="$t('hotel.detail.test')" />
                    </v-col>
                </v-row>

                <div class="hotel-modal-title mt-3">{{ $t('hotel.detail.title_hotel_description') }}</div>

                <v-row no-gutters>
                    <v-col cols="12">
                        <v-tabs v-model="description" slider-color="primary" right class="py-0 my-0">
                            <!-- hotel description -->
                            <v-tab ripple>
                                <v-avatar size="24" class="mr-2" tile>
                                    <img :src="ro" alt="alt">
                                </v-avatar>Romana
                            </v-tab>
                            <v-tab-item>
                                <v-textarea :class="{'description-warning':(warning_message_ro.length >0)}" label="Descriere unitate" auto-grow v-model="item.description.ro" filled :messages="warning_message_ro" />
                            </v-tab-item>
                            <v-tab ripple>
                                <v-avatar size="24" class="mr-2" tile>
                                    <img :src="gb" alt="alt">
                                </v-avatar>English
                            </v-tab>
                            <v-tab-item>
                                <v-textarea label="Description" auto-grow v-model="item.description.en" filled required />
                            </v-tab-item>
                        </v-tabs>
                        <div class="faded px-2">
                            {{ $t('hotel.modal.detail.info_text.description') }}
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="!valid" :loading="loading_save" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import ro_flag from '../../../../assets/ro.svg';
import gb_flag from '../../../../assets/gb.svg';
import storage from '../../../../storage';

export default {
    props: {
        dialog: Boolean,
        item: Object,
        config: Object
    },
    name: `hotel-details`,
    components: {},
    data() {
        return {
            is_dirty: false,
            valid: false,
            admin: false,
            ro: ro_flag,
            gb: gb_flag,
            tab_hotel: null,
            description: null,
            hover: false,
            loading_save: false,
            original_slug: null,
            // input input items,
            languages: [],
            stars: [],

            chain: false,
            clasification: (this.item.static.defaults.stars > 0 && this.item.static.defaults.certificate_status == "active"),

            context: [
                {
                    text: "iMemento",
                    value: "imemento"
                }, {
                    text: "YieldPlanet",
                    value: "yieldplanet"
                }, {
                    text: "PynBooking",
                    value: "pynbooking"
                }, {
                    text: "WebHotelier",
                    value: "webhotelier"
                }, {
                    text: "FiveStar",
                    value: "fivestar"
                }, {
                    text: "CM Start",
                    value: "cmstart"
                }
            ],


        };
    },

    watch: {
        clasification: {
            handler() {
                if(this.clasification) {
                    this.item.static.defaults.certificate_status = "active"
                } else {
                    this.item.static.defaults.certificate_status = "not-certified"
                }
            }
        }

    },

    async mounted() {
        this.original_slug = this.item.slug;
        this.item.static.defaults.stars = Number(this.item.static.defaults.stars);
        if((this.item.static.defaults.stars > 0) && (this.item.static.defaults.certificate_status == "active")) {
            this.clasification = true;
        } else {
            this.clasification = false;
        }
        this.checkChain();
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    computed: {

        rule_clasification() {
            if(this.clasification) {
                return this.rules.clasification
            } else {
                return []
            }
        },
        rule_chain() {
            if(this.chain) {
                return this.rules.chain
            } else {
                return []
            }
        },

        warning_message_ro() {
            let ro = this.item.description.ro;
            if(ro) {
                if(ro.length < 200) {
                    return ["Your hotel is better. *min 200 caractere"]
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        warning_message_en() {
            let en = this.item.description.en;
            if(en) {
                if(en.length < 200) {
                    return ["Your hotel is better. *min 200 characters"]
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        status_hotel() {
            return [
                {
                    text: this.$t('hotel.detail.status.registered'),
                    value: "registered"
                }, {
                    text: this.$t('hotel.detail.status.accepted'),
                    value: "accepted"
                }, {
                    text: this.$t('hotel.detail.status.published'),
                    value: "published"
                }, {
                    text: this.$t('hotel.detail.status.suspended'),
                    value: "suspended"
                }, {
                    text: this.$t('hotel.detail.status.refused_by_us'),
                    value: "refused-by-us"
                }, {
                    text: this.$t('hotel.detail.status.refused_by_them'),
                    value: "refused-by-them"
                }
            ]
        },
        boolean_values() {
            return [
                {
                    text: this.$t('hotel.detail.boolean_values.yes'),
                    value: '1'
                }, {
                    text: this.$t('hotel.detail.boolean_values.no'),
                    value: '0'
                }
            ]
        },
        rules() {
            return {
                name: [v => !!v || this.$t('hotel.detail.form_rules.name')],
                type: [v => !!v || this.$t('hotel.detail.form_rules.type')],
                chain: [v => !!v || this.$t('hotel.detail.form_rules.chain')],
                slug: [
                    v => !!v || this.$t('hotel.detail.form_rules.slug'),
                    v => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(v) || this.$t('hotel.detail.form_rules.slug')
                ],
                capacity: [v => !!v || this.$t('hotel.detail.form_rules.capacity')],
                context: [v => !!v || this.$t('hotel.detail.form_rules.context')],
                clasification: [v => !!v || this.$t('hotel.detail.form_rules.clasification')],
                description: [v => !!v || this.$t('hotel.detail.form_rules.description')]
            }
        }

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        checkChain() {
            switch (this.item.static.defaults.chain) {
            case null:
                this.chain = false;
                break;
            case undefined:
                this.chain = false;
                break;
            case '':
                this.chain = false;
                break;
            default:
                this.chain = true;
            }
        },

        save() {
            this.loading_save = true;
            if(this.original_slug == this.item.slug) {
                this.saveItem();
            } else {
                this.checkSlug(0);
            }
        },

        checkSlug(i) {
            let new_slug = this.item.slug
            if(i !== 0) {
                new_slug = this.item.slug + "-" + i;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: new_slug
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        // slug exists,  call again whith different slug
                        this.checkSlug(i + 1);
                    } else {
                        // slug ok, save hotel with diff slug
                        this.item.slug = new_slug;
                        this.saveItem();
                    }

                })
                .catch(error => {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        saveItem() {
            this.loading_save = true;
            // prepare some data for saving
            let model = {
                name: this.item.name,
                unit_type: this.item.unit_type,
                context: this.item.context,
                status: this.item.status,
                slug: this.item.slug,
                net_commission: this.item.net_commission,
                gross_commission: this.item.gross_commission,
                description: {
                    ro: this.item.description.ro,
                    en: this.item.description.en
                },
                static: {
                    for_testing: this.item.static.for_testing,
                    defaults: {
                        chain: this.item.static.defaults.chain,
                        certificate: this.item.static.defaults.certificate,
                        capacity: this.item.static.defaults.capacity,
                        stars: this.item.static.defaults.stars,
                        certificate_status: this.item.static.defaults.certificate_status
                    },

                }
            };
            let hotel = this.$clone(this.item);
            delete hotel.address;
            hotel.static.images = [];
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            this.$axios.put(endpoint + this.item.id, hotel)
                .then(response => {
                    this.$emit('update')
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

        emitExit() {
            this.$emit('exit')
        }
    },
};
</script>

<style lang="stylus">
.weekend-days .v-btn
    min-width: 55px
.description-warning
    &.v-input
        .v-text-field__details
            .v-messages
                .v-messages__message
                    color: orangered
//
</style>
